import script from "./SenderReceiversPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./SenderReceiversPreview.vue?vue&type=script&lang=ts&setup=true"

import "./SenderReceiversPreview.vue?vue&type=style&index=0&id=ff008818&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff008818"]])

export default __exports__